import { hexagon } from '../config'
import { Description } from '../Description'
import { TopRightHexagon } from '../styles'

import {
  LeftHexagon,
  stepTitleStyles,
  Wrapper,
  BottomRightHexagon,
  ProcessContainer,
} from './styles'
import { ProcessProps } from './types'

export function Process({ description, steps }: ProcessProps) {
  return (
    <ProcessContainer>
      <Wrapper>
        <Description {...description} />
        {steps.map(step => (
          <Description
            titleAs="h3"
            titleAdditionalStyles={stepTitleStyles}
            key={step.title}
            {...step}
          />
        ))}
      </Wrapper>
      <LeftHexagon />
      <TopRightHexagon {...hexagon} />
      <BottomRightHexagon {...hexagon} />
    </ProcessContainer>
  )
}
